import ActionType from './ActionType'

export const toggleDialog = payload => dispatch =>
  dispatch({ type: ActionType.LogoManagement.TOGGLE_DIALOG, payload })

export const changeLogoUrl = payload => dispatch =>
  dispatch({ type: ActionType.LogoManagement.CHANGE_LOGO_URL, payload })
